import { z } from 'zod'
import type { Addresses, Customers } from './pbSchema'

export type Customer = Omit<Customers, 'org' | 'address'>
export type Address = Addresses

export type CustomerFormData = {
    id?: string
    name: string
    identifier: string
    notes?: string
    expand?: {
        address?: {
            id?: string
            line1?: string
            line2?: string
            city?: string
            stateProvinceCounty?: string
            zipOrPostcode?: string
            country?: string
            org?: string
        }
    }
}

type CustomerWithAddress = Customer & { address: Address }

export type { CustomerWithAddress }

export interface DeleteDialogState {
    open: boolean
    state: { customerId: string; customerName: string; organizationId: string } | null
}

export { formatAddress, isAddressBlank } from '@/lib/address-utils'

export const customerSchema = z.object({
    name: z.string().min(1, 'Customer name is required'),
    identifier: z
        .string()
        .min(1, 'Customer identifier is required')
        .regex(/^[a-z0-9-]+$/, 'Identifier must contain only lowercase letters, numbers, and hyphens'),
    notes: z.string().optional(),
})

export const addressSchema = z.object({
    line1: z.string().optional().default(''),
    line2: z.string().optional().default(''),
    city: z.string().optional().default(''),
    stateProvinceCounty: z.string().optional().default(''),
    zipOrPostcode: z.string().optional().default(''),
    country: z.string().optional().default(''),
})

export const customerFormSchema = customerSchema.extend({
    id: z.string().optional(),
    expand: z
        .object({
            address: addressSchema
                .extend({
                    id: z.string().optional(),
                    org: z.string().optional(),
                })
                .optional(),
        })
        .optional(),
})

export const customerWithAddressSchema = customerFormSchema
